import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store";
import "./scss/tw.css";
import "./scss/index.scss";
// import "sonner/dist/style.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ColorModeScript } from "@chakra-ui/react";
import theme from "./theme";
import "./i18n";
import GlobalErrorBoundary from "./components/error/GlobalErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    {/* <GlobalErrorBoundary> */}
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <App />
    {/* </GlobalErrorBoundary> */}
  </Provider>
);

reportWebVitals();
